export const getIsSafariBrowser = () => {
  if (typeof navigator === 'undefined') return false
  const userAgent = navigator.userAgent
  return /Safari/i.test(userAgent)
    && !/Chrome|Chromium|CriOS|FxiOS|Edg/i.test(userAgent)
}
